import React, { useState } from "react";
import { UserOutlined, ShoppingCartOutlined, HeartOutlined, SettingOutlined, LogoutOutlined, DownOutlined, } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useSettings } from "../context/settingContext";

const SideBar = () => {
    const [openSettings, setOpenSettings] = useState(false);
    const { Logout } = useSettings();

    return (
        <ul className="space-y-6 font-medium">
            <li className="flex items-center gap-2 cursor-pointer hover:text-yellow-400 transition p-2">
                <UserOutlined /> <Link to="/dashboard/">Dashboard</Link>
            </li>
            <li className="flex items-center gap-2 cursor-pointer hover:text-yellow-400 transition p-2">
                <ShoppingCartOutlined /> <Link to="/dashboard/orders">My Orders</Link>
            </li>
            <li className="flex items-center gap-2 cursor-pointer hover:text-yellow-400 transition p-2">
                <HeartOutlined /> <Link to="/dashboard/wishlist">Wishlist</Link>
            </li>
            <li>
                <div
                    className="flex items-center justify-between cursor-pointer p-2 rounded-md bg-black transition"
                    onClick={() => setOpenSettings(!openSettings)}
                >
                    <div className="flex items-center gap-2">
                        <SettingOutlined /> Account Settings
                    </div>
                    <DownOutlined
                        className={`text-xs p-1 bg-brandBlue rounded transition-transform duration-300 ${openSettings ? "rotate-180 text-yellow-400" : ""
                            }`}
                    />
                </div>

                <div
                    className={`overflow-hidden transition-all duration-500 ease-in-out ${openSettings ? "max-h-40 opacity-100 mt-2" : "max-h-0 opacity-0"
                        }`}
                >
                    <ul className="ml-6 space-y-3 text-sm text-gray-600">
                        <li className="hover:pl-2 transition-all">
                            <Link to="/dashboard/profile" className="text-white hover:text-yellow-400">👤 Profile</Link>
                        </li>
                        <li className="hover:pl-2 transition-all">
                            <Link to="/dashboard/reset-password" className="text-white hover:text-yellow-400">🔑 Change Password</Link>
                        </li>
                    </ul>
                </div>
            </li>
            <li className="flex items-center gap-2 cursor-pointer hover:text-red-500 transition p-2">
                <LogoutOutlined /> <Link to="#" onClick={Logout}>Logout</Link>
            </li>
        </ul>
    );
};

export default SideBar;
